import { render, staticRenderFns } from "./ImageHandler.vue?vue&type=template&id=3cc0cf5d&"
import script from "./ImageHandler.vue?vue&type=script&lang=js&"
export * from "./ImageHandler.vue?vue&type=script&lang=js&"
import style0 from "./ImageHandler.vue?vue&type=style&index=0&id=3cc0cf5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports